<div class="doc-scope bg-transparent" [class.doc-scope--no-comptable]="!showComptable"
    [class.doc-scope--dense]="dense" [innerHTML]="safeHtml" (click)="onClickContent($event)"></div>
